import React from "react";
import { Table, Button } from "reactstrap";
import { FaArrowUp, FaInfoCircle } from "react-icons/fa";
import RoundedDropdown from "../../../Component/BasicComponents/Dropdowns/RoundedDropdown";

const data = [
  { brand: "Crina Ncr", tagDrs: 365, febRx: 345, janRx: 330, count: 17 },
  { brand: "Vehycal Xt", tagDrs: 149, febRx: 131, janRx: 121, count: 12 },
  { brand: "Isoft", tagDrs: 227, febRx: 196, janRx: 190, count: 12 },
];

const GrowPrescriberTable = () => {
  return (
    <div>
      <div className="d-flex justify-content-between align-items-center mb-3">
        <h5 style={{ fontWeight: "600", display: "flex" }}>
          Grow Prescriber Analysis
        </h5>
        <div className="d-flex gap-2">
          <RoundedDropdown
            options={[]}
            onSelect={(e: any) => {
              console.log(e);
            }}
            defaultLabel="All Specialities"
            width="auto"
            headingColor="#2e8dd3"
            DropdownHeading=""
            backgroundColor="success"
          />
          <RoundedDropdown
            options={[]}
            onSelect={(e: any) => {
              console.log(e);
            }}
            defaultLabel="All Specialities"
            width="auto"
            headingColor="#2e8dd3"
            DropdownHeading=""
            backgroundColor="success"
          />
        </div>
      </div>

      <Table bordered responsive style={{ marginBottom: 0 }}>
        <thead style={{ backgroundColor: "#ECF7F9" }}>
          <tr style={{ color: "#83AFC2" }}>
            <th>SGPI Brands</th>
            <th>Tag Drs</th>
            <th>February Rxber</th>
            <th>January Rxber</th>
            <th>Count</th>
            <th></th>
          </tr>
        </thead>
        <tbody>
          {data.map((item, idx) => (
            <tr key={idx} style={{ fontWeight: 600, color: "#000" }}>
              <td>
                <FaInfoCircle color="#A3A3A3" style={{ marginRight: 6 }} />
                {item.brand}
              </td>
              <td>{item.tagDrs}</td>
              <td>{item.febRx}</td>
              <td>{item.janRx}</td>
              <td style={{ color: "#35A958" }}>
                <FaArrowUp size={12} style={{ marginRight: 4 }} />
                {item.count}
              </td>
              <td>
                <Button
                  size="sm"
                  color="success"
                  style={{ borderRadius: 20, fontWeight: 500 }}
                >
                  View
                </Button>
              </td>
            </tr>
          ))}
        </tbody>
      </Table>
    </div>
  );
};

export default GrowPrescriberTable;
